import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */
import { assertPrivate, defineProperties } from "../utils/index.js";
var _gaurd = {};
function n(value, width) {
  var signed = false;
  if (width < 0) {
    signed = true;
    width *= -1;
  }
  // @TODO: Check range is valid for value
  return new Typed(_gaurd, "".concat(signed ? "" : "u", "int").concat(width), value, {
    signed: signed,
    width: width
  });
}
function b(value, size) {
  // @TODO: Check range is valid for value
  return new Typed(_gaurd, "bytes".concat(size ? size : ""), value, {
    size: size
  });
}
var _typedSymbol = Symbol.for("_ethers_typed");
/**
 *  The **Typed** class to wrap values providing explicit type information.
 */
var _options = /*#__PURE__*/new WeakMap();
export var Typed = /*#__PURE__*/function () {
  /**
   *  The type, as a Solidity-compatible type.
   */

  /**
   *  The actual value.
   */

  /**
   *  @_ignore:
   */

  /**
   *  @_ignore:
   */
  function Typed(gaurd, type, value, options) {
    _classCallCheck(this, Typed);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "value", void 0);
    _classPrivateFieldInitSpec(this, _options, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "_typedSymbol", void 0);
    if (options == null) {
      options = null;
    }
    assertPrivate(_gaurd, gaurd, "Typed");
    defineProperties(this, {
      _typedSymbol: _typedSymbol,
      type: type,
      value: value
    });
    _classPrivateFieldSet(this, _options, options);
    // Check the value is valid
    this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  _createClass(Typed, [{
    key: "format",
    value: function format() {
      if (this.type === "array") {
        throw new Error("");
      } else if (this.type === "dynamicArray") {
        throw new Error("");
      } else if (this.type === "tuple") {
        return "tuple(".concat(this.value.map(function (v) {
          return v.format();
        }).join(","), ")");
      }
      return this.type;
    }
    /**
     *  The default value returned by this type.
     */
  }, {
    key: "defaultValue",
    value: function defaultValue() {
      return 0;
    }
    /**
     *  The minimum value for numeric types.
     */
  }, {
    key: "minValue",
    value: function minValue() {
      return 0;
    }
    /**
     *  The maximum value for numeric types.
     */
  }, {
    key: "maxValue",
    value: function maxValue() {
      return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */
  }, {
    key: "isBigInt",
    value: function isBigInt() {
      return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */
  }, {
    key: "isData",
    value: function isData() {
      return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */
  }, {
    key: "isString",
    value: function isString() {
      return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */
  }, {
    key: "tupleName",
    get: function get() {
      if (this.type !== "tuple") {
        throw TypeError("not a tuple");
      }
      return _classPrivateFieldGet(this, _options);
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */
  }, {
    key: "arrayLength",
    get: function get() {
      if (this.type !== "array") {
        throw TypeError("not an array");
      }
      if (_classPrivateFieldGet(this, _options) === true) {
        return -1;
      }
      if (_classPrivateFieldGet(this, _options) === false) {
        return this.value.length;
      }
      return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */
  }], [{
    key: "from",
    value: function from(type, value) {
      return new Typed(_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
  }, {
    key: "uint8",
    value: function uint8(v) {
      return n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */
  }, {
    key: "uint16",
    value: function uint16(v) {
      return n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */
  }, {
    key: "uint24",
    value: function uint24(v) {
      return n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */
  }, {
    key: "uint32",
    value: function uint32(v) {
      return n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */
  }, {
    key: "uint40",
    value: function uint40(v) {
      return n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */
  }, {
    key: "uint48",
    value: function uint48(v) {
      return n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */
  }, {
    key: "uint56",
    value: function uint56(v) {
      return n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */
  }, {
    key: "uint64",
    value: function uint64(v) {
      return n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */
  }, {
    key: "uint72",
    value: function uint72(v) {
      return n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */
  }, {
    key: "uint80",
    value: function uint80(v) {
      return n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */
  }, {
    key: "uint88",
    value: function uint88(v) {
      return n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */
  }, {
    key: "uint96",
    value: function uint96(v) {
      return n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */
  }, {
    key: "uint104",
    value: function uint104(v) {
      return n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */
  }, {
    key: "uint112",
    value: function uint112(v) {
      return n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */
  }, {
    key: "uint120",
    value: function uint120(v) {
      return n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */
  }, {
    key: "uint128",
    value: function uint128(v) {
      return n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */
  }, {
    key: "uint136",
    value: function uint136(v) {
      return n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */
  }, {
    key: "uint144",
    value: function uint144(v) {
      return n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */
  }, {
    key: "uint152",
    value: function uint152(v) {
      return n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */
  }, {
    key: "uint160",
    value: function uint160(v) {
      return n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */
  }, {
    key: "uint168",
    value: function uint168(v) {
      return n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */
  }, {
    key: "uint176",
    value: function uint176(v) {
      return n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */
  }, {
    key: "uint184",
    value: function uint184(v) {
      return n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */
  }, {
    key: "uint192",
    value: function uint192(v) {
      return n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */
  }, {
    key: "uint200",
    value: function uint200(v) {
      return n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */
  }, {
    key: "uint208",
    value: function uint208(v) {
      return n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */
  }, {
    key: "uint216",
    value: function uint216(v) {
      return n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */
  }, {
    key: "uint224",
    value: function uint224(v) {
      return n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */
  }, {
    key: "uint232",
    value: function uint232(v) {
      return n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */
  }, {
    key: "uint240",
    value: function uint240(v) {
      return n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */
  }, {
    key: "uint248",
    value: function uint248(v) {
      return n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
  }, {
    key: "uint256",
    value: function uint256(v) {
      return n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
  }, {
    key: "uint",
    value: function uint(v) {
      return n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */
  }, {
    key: "int8",
    value: function int8(v) {
      return n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */
  }, {
    key: "int16",
    value: function int16(v) {
      return n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */
  }, {
    key: "int24",
    value: function int24(v) {
      return n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */
  }, {
    key: "int32",
    value: function int32(v) {
      return n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */
  }, {
    key: "int40",
    value: function int40(v) {
      return n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */
  }, {
    key: "int48",
    value: function int48(v) {
      return n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */
  }, {
    key: "int56",
    value: function int56(v) {
      return n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */
  }, {
    key: "int64",
    value: function int64(v) {
      return n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */
  }, {
    key: "int72",
    value: function int72(v) {
      return n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */
  }, {
    key: "int80",
    value: function int80(v) {
      return n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */
  }, {
    key: "int88",
    value: function int88(v) {
      return n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */
  }, {
    key: "int96",
    value: function int96(v) {
      return n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */
  }, {
    key: "int104",
    value: function int104(v) {
      return n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */
  }, {
    key: "int112",
    value: function int112(v) {
      return n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */
  }, {
    key: "int120",
    value: function int120(v) {
      return n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */
  }, {
    key: "int128",
    value: function int128(v) {
      return n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */
  }, {
    key: "int136",
    value: function int136(v) {
      return n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */
  }, {
    key: "int144",
    value: function int144(v) {
      return n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */
  }, {
    key: "int152",
    value: function int152(v) {
      return n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */
  }, {
    key: "int160",
    value: function int160(v) {
      return n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */
  }, {
    key: "int168",
    value: function int168(v) {
      return n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */
  }, {
    key: "int176",
    value: function int176(v) {
      return n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */
  }, {
    key: "int184",
    value: function int184(v) {
      return n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */
  }, {
    key: "int192",
    value: function int192(v) {
      return n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */
  }, {
    key: "int200",
    value: function int200(v) {
      return n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */
  }, {
    key: "int208",
    value: function int208(v) {
      return n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */
  }, {
    key: "int216",
    value: function int216(v) {
      return n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */
  }, {
    key: "int224",
    value: function int224(v) {
      return n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */
  }, {
    key: "int232",
    value: function int232(v) {
      return n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */
  }, {
    key: "int240",
    value: function int240(v) {
      return n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */
  }, {
    key: "int248",
    value: function int248(v) {
      return n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
  }, {
    key: "int256",
    value: function int256(v) {
      return n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
  }, {
    key: "int",
    value: function int(v) {
      return n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */
  }, {
    key: "bytes1",
    value: function bytes1(v) {
      return b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */
  }, {
    key: "bytes2",
    value: function bytes2(v) {
      return b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */
  }, {
    key: "bytes3",
    value: function bytes3(v) {
      return b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */
  }, {
    key: "bytes4",
    value: function bytes4(v) {
      return b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */
  }, {
    key: "bytes5",
    value: function bytes5(v) {
      return b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */
  }, {
    key: "bytes6",
    value: function bytes6(v) {
      return b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */
  }, {
    key: "bytes7",
    value: function bytes7(v) {
      return b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */
  }, {
    key: "bytes8",
    value: function bytes8(v) {
      return b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */
  }, {
    key: "bytes9",
    value: function bytes9(v) {
      return b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */
  }, {
    key: "bytes10",
    value: function bytes10(v) {
      return b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */
  }, {
    key: "bytes11",
    value: function bytes11(v) {
      return b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */
  }, {
    key: "bytes12",
    value: function bytes12(v) {
      return b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */
  }, {
    key: "bytes13",
    value: function bytes13(v) {
      return b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */
  }, {
    key: "bytes14",
    value: function bytes14(v) {
      return b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */
  }, {
    key: "bytes15",
    value: function bytes15(v) {
      return b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */
  }, {
    key: "bytes16",
    value: function bytes16(v) {
      return b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */
  }, {
    key: "bytes17",
    value: function bytes17(v) {
      return b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */
  }, {
    key: "bytes18",
    value: function bytes18(v) {
      return b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */
  }, {
    key: "bytes19",
    value: function bytes19(v) {
      return b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */
  }, {
    key: "bytes20",
    value: function bytes20(v) {
      return b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */
  }, {
    key: "bytes21",
    value: function bytes21(v) {
      return b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */
  }, {
    key: "bytes22",
    value: function bytes22(v) {
      return b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */
  }, {
    key: "bytes23",
    value: function bytes23(v) {
      return b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */
  }, {
    key: "bytes24",
    value: function bytes24(v) {
      return b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */
  }, {
    key: "bytes25",
    value: function bytes25(v) {
      return b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */
  }, {
    key: "bytes26",
    value: function bytes26(v) {
      return b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */
  }, {
    key: "bytes27",
    value: function bytes27(v) {
      return b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */
  }, {
    key: "bytes28",
    value: function bytes28(v) {
      return b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */
  }, {
    key: "bytes29",
    value: function bytes29(v) {
      return b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */
  }, {
    key: "bytes30",
    value: function bytes30(v) {
      return b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */
  }, {
    key: "bytes31",
    value: function bytes31(v) {
      return b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */
  }, {
    key: "bytes32",
    value: function bytes32(v) {
      return b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */
  }, {
    key: "address",
    value: function address(v) {
      return new Typed(_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */
  }, {
    key: "bool",
    value: function bool(v) {
      return new Typed(_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */
  }, {
    key: "bytes",
    value: function bytes(v) {
      return new Typed(_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */
  }, {
    key: "string",
    value: function string(v) {
      return new Typed(_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */
  }, {
    key: "array",
    value: function array(v, dynamic) {
      throw new Error("not implemented yet");
      return new Typed(_gaurd, "array", v, dynamic);
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */
  }, {
    key: "tuple",
    value: function tuple(v, name) {
      throw new Error("not implemented yet");
      return new Typed(_gaurd, "tuple", v, name);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
  }, {
    key: "overrides",
    value: function overrides(v) {
      return new Typed(_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */
  }, {
    key: "isTyped",
    value: function isTyped(value) {
      return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === _typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */
  }, {
    key: "dereference",
    value: function dereference(value, type) {
      if (Typed.isTyped(value)) {
        if (value.type !== type) {
          throw new Error("invalid type: expecetd ".concat(type, ", got ").concat(value.type));
        }
        return value.value;
      }
      return value;
    }
  }]);
  return Typed;
}();